export default "__VITE_ASSET__h8UrjWqg__"